<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <form class="form-horizontal" #newVesselForm="ngForm">
          <div class="form-group row">
            <app-material-pg-input
                label="Name"
                type="text"
                name="vesselName"
                id="vesselName"
                tabindex="1"
                [(ngModel)]="name"
                [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="IMO"
                type="text"
                name="lpgPricePayment"
                id="lpgPricePayment"
                tabindex="2"
                [(ngModel)]="imo"
                [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector
              id="flag"
              class="pg-component"
              [(ngModel)]="flag"
              [organisationLanguage]="'en'"
              name="flag"
              [organisations]="flags"
              [placeholder]="'Flag'"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="form-group pull-right">
            <label for="newVessel" class="col-form-label col-md-4"></label>
            <div class="form-group">
              <button
                mat-raised-button
                mat-stroked-button
                type="submit"
                id="newVessel"
                class="pull-right "
                value="Save"
                [disabled]="!newVesselForm.form.valid"
                (click)="addVessel()">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>